import Grid from '@material-ui/core/Grid';
import React from 'react';
import StyledBadge from '../../Atoms/SimpleStyledBadge';
import Typography from '@material-ui/core/Typography';
import UserList from '../../Atoms/UserList';

interface IUserSelection {
    initiallySelected?: any;
    label: string;
    userSelectionHook: any;
}
const UserSelection = ({ label, userSelectionHook }: IUserSelection) => {
    const { checked, checkedCount, handleSelection, selectableUsers } = userSelectionHook;
    return (
        <React.Fragment>
            <Grid container id="label" spacing={3}>
                <Grid
                    alignItems="center"
                    container
                    data-cy={`${label}-active-users-panel`}
                    direction="column"
                    item
                    md={6}
                    xs={12}
                >
                    <StyledBadge
                        badgeContent={selectableUsers ? selectableUsers.length : 0}
                        color="secondary"
                        max={10000}
                    >
                        <Typography component="h3" variant="h6">
                            Active event users
                        </Typography>
                    </StyledBadge>

                    <UserList
                        editable={true}
                        handleSelection={handleSelection}
                        id={`${label}-selection`}
                        users={selectableUsers}
                    />
                </Grid>
                <Grid
                    alignItems="center"
                    container
                    data-cy={`${label}-selected-users-panel`}
                    direction="column"
                    item
                    md={6}
                    xs={12}
                >
                    <StyledBadge badgeContent={checkedCount} color="secondary" max={10000}>
                        <Typography component="h3" variant="h6">
                            Selected users/groups
                        </Typography>
                    </StyledBadge>
                    <UserList handleSelection={handleSelection} id={`${label}-selected`} users={checked} />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default UserSelection;
